export default {
  form: {
    address: {
      delivery: {
        placeholder: 'Søg efter din leveringsadresse',
      },
      placeholder: 'Indtast adresse for at finde nærmeste lokation',
    },
  },
  toasts: {
    failed_to_load_stores: 'Butikkerne kunne ikke indlæses. Opdater siden',
  },
  errors: {
    no_delivery_companies: 'Levering er ikke tilgængelig til denne adresse',
    delivery_not_available: 'Vi tilbyder desværre ikke levering i øjeblikket',
    location_unavailable: 'Kunne ikke få adgang til din placering. Aktiver tilladelser, eller indtast adressen manuelt',
    location_lookup_failed: 'Kunne ikke finde din adresse. Prøv igen',
    address_suggestions_unavailable: 'Adresseforslag kunne ikke indlæses.',
  },
  buttons: {
    use_current_location: 'Brug min nuværende placering',
    locating: 'Finder din placering…',
    retry: 'Prøv igen',
  },
};
